import { useState } from 'react';
import clsx from 'clsx';
import { DefaultProps } from '../../common/types';
import { styled } from '@mui/material';

export interface SuggestedText {
    label: string;
    text: string;
}

interface MultiLineTextSuggestionProps extends DefaultProps {
    suggestedText?: SuggestedText;
    expanded?: boolean;
    onClick?: () => void;
}

function MultiLineTextSuggestionComponent({
    suggestedText,
    expanded,
    onClick,
    className,
}: MultiLineTextSuggestionProps) {
    const [hovered, setHovered] = useState(false);

    if (!suggestedText) {
        return null;
    }

    return (
        <div
            className={clsx(className, { expanded: expanded || hovered })}
            onClick={onClick}
            title={suggestedText?.text}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            💡<span className="suggestion-label">{suggestedText?.label}</span>
        </div>
    );
}

export const MultiLineTextSuggestion = styled(MultiLineTextSuggestionComponent, {
    name: 'MultiLineTextSuggestion',
})(({ theme }) => ({
    position: 'absolute',
    top: 4,
    right: 16,
    color: theme.app.neutralColor.textDefault,
    zIndex: 1,
    fontSize: 11,
    transition: 'max-width 0.3s ease-in-out',
    width: 'content',
    borderRadius: 4,
    padding: 2,
    border: `1px solid transparent`,
    '&:hover': {
        cursor: 'pointer',
        color: theme.app.accentColor.textHover,
        borderColor: theme.app.neutralColor.borderMain,
    },
    maxWidth: '20px',
    '& .suggestion-label': {
        transition: 'color 0.5s ease',
    },
    '&.expanded': {
        maxWidth: '300px',
    },
    '&:not(.expanded) .suggestion-label': {
        color: 'transparent',
    },
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
}));
